import React, { useEffect, useRef, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

export default function DashboardConsorcioHeader({ data }) {
  const { bigNumbers } = data;
  const [usuario, setUsuario] = useState(JSON.parse(localStorage.getItem('@areacliente/user')) == null ? "" : JSON.parse(localStorage.getItem('@areacliente/user')).fullname);
  const [statusPagamento, setStatusPagamento] = useState("");

  const dispatch = useDispatch();

  const {
    usuarioNomeAlterar,
    currentState
  } = useSelector(
    (state) => ({
      usuarioNomeAlterar: state.usuarios.usuarioNomeAlterar,
      currentState: state.dashboardConsorcio
    }),
    shallowEqual
  );

  const { entities } = currentState;

  function contarSituacao(array) {
    let situacaoP = 0;
    let situacaoA = 0;
    let situacaoV = 0;

    array.forEach(objeto => {
      if (objeto.statusPagamento === 'P') {
        situacaoP++;
      } else if (objeto.statusPagamento === 'A') {
        situacaoA++;
      } else if (objeto.statusPagamento === 'V') {
        situacaoV++;
      }
    });

    if (situacaoA == 0 && situacaoV == 0) {
      return "Pago"
    } else if (situacaoA == 0 && situacaoV > 0) {
      return"Vencido"
    } else if (situacaoA > 0) {
      return "Pendente"
    }
    // return { situacaoP, situacaoA };
  }

  useEffect(() => {
    if (bigNumbers) {
      if (entities != undefined && entities != null && entities.length >= 1) {
        const resultado = contarSituacao(entities);
        setStatusPagamento(resultado);
      }

    }
  }, [bigNumbers,entities])


  useEffect(() => {
    if (usuarioNomeAlterar !== undefined) {
      setUsuario(usuarioNomeAlterar)
    }
  }, [usuarioNomeAlterar, dispatch]);

  function htmlStatusPagamento() {
    if (statusPagamento === "Pendente") {
      return (
        <div className="flex items-center justify-center bg-yellow-100 rounded-lg px-6 md:px-20 py-2">
          <h3 className="text-lg md:text-xl   font-bold text-yellow-600">{statusPagamento}</h3>
        </div>
      );
    } else if (statusPagamento === "Pago") {
      return (
        <div className="flex items-center justify-center bg-green-100 rounded-lg px-6 md:px-20 py-2">
          <h3 className="text-lg md:text-xl   font-bold text-green-600">{statusPagamento}</h3>
        </div>
      );
    } else if (statusPagamento === "Vencido") {
      return (
        <div className="flex items-center justify-center bg-red-100 rounded-lg px-6 md:px-20 py-2">
          <h3 className="text-lg md:text-xl   font-bold text-red-600">{statusPagamento}</h3>
        </div>
      );
    } else {
      return
    };
  };

  // useEffect(() => {
  //   if (bigNumbers) {
  //     if (bigNumbers.situacao === "P") {
  //       setStatusPagamento("Pendente");
  //     } else if (bigNumbers.situacao === "A") {
  //       setStatusPagamento("Pago");
  //     } else if (bigNumbers.situacao === "V") {
  //       setStatusPagamento("Vencido");
  //     } else {
  //       setStatusPagamento("")
  //     };
  //   };
  // }, [bigNumbers])

  return (
    <div className="bg-white p-4 rounded-lg flex items-center justify-between drop-shadow">
      <div className="flex items-center gap-1.5 md:gap-3">
        <img
          className="h-10 w-10 md:h-12 md:w-12 rounded-full"
          src="/images/usuario_avatar.svg"
          alt=""
        />
        <h2 className="text-lg md:text-2xl font-bold text-gray-600">
          Olá, {usuario}!
        </h2>
      </div>
      {entities && htmlStatusPagamento()}
    </div>
  );
}
